import api from "src/api/index";
import {STATE_MEDIA} from "src/config";

export async function getEventHints(){
    try {
        const response =  await api.get(STATE_MEDIA + "api/dashboard/hints-events")
        return response.data?.items ?? []
    } catch (error) {
        console.error("ошибка загрузки мероприятий", error?.message)
    }
}

